import React from "react";

import { Field, Inputs, useFieldValue } from "2g-form";

import useMessages from "./i18n/useMessages";

export function RezervaceVytvoreniPoznamka() {
  const { poznamkaLabel } = useMessages();
  const produkt = useFieldValue("produkt");

  return produkt ? (
    <Field
      label={poznamkaLabel()}
      component={Inputs.TextArea}
      path="poznamka"
    />
  ) : undefined;
}

RezervaceVytvoreniPoznamka.propTypes = {};

export default React.memo(RezervaceVytvoreniPoznamka);
